<script lang="ts" setup>
import { computed } from 'vue'

import { useBetStatus } from '@desktop/views/Relation/composables'
import PitchIncidentsSeparator from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchIncidents/PitchIncidentsSeparator.vue'
import PitchParticipantIncidentsTeamSide from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchIncidents/PitchParticipantWithIncidents/PitchParticipantIncidentsTeamSide.vue'

import {
  useBaseballParticipants,
  useEventDetailHalf,
} from '../../../../composables'
import BaseRunners from './BaseRunners/BaseRunners.vue'
import Matchup from './Matchup/Matchup.vue'
import ParticipantIncidents from './ParticipantIncidents.vue'

// composables
const { battingParticipant: participant } = useBaseballParticipants()
const { isMainBetMarketSuspended } = useBetStatus()

// computed
const mainBetMarketSuspended = computed(() => isMainBetMarketSuspended())
const { eventDetailHalfValue } = useEventDetailHalf()
</script>

<template>
  <PitchParticipantIncidentsTeamSide
    v-if="participant"
    class="grid flex-1 grid-cols-[1fr_auto_1fr] border-2 px-2 pt-3 pb-2.5"
    :class="{
      'border-error-5': mainBetMarketSuspended,
      'border-transparent': !mainBetMarketSuspended,
    }"
    :participant
  >
    <div>
      <Matchup />
      <BaseRunners :key="eventDetailHalfValue" />
    </div>
    <PitchIncidentsSeparator class="mx-2" />
    <ParticipantIncidents />
  </PitchParticipantIncidentsTeamSide>
</template>
